const ua = navigator.userAgent,
  isWindowsPhone = /(?:Windows Phone)/.test(ua),
  isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
  isFireFox = /(?:Firefox)/.test(ua),
  /*   isChrome = /(?:Chrome)/.test(ua), */
  /*   isSafari = /(?:Safari)/.test(ua) && !isChrome, */
  isAndroid = /(?:Android)/.test(ua),
  isTablet =
    /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
  /*   isIPad = /(?:iPad)/.test(ua), */
  isPhone = /(?:iPhone)/.test(ua) && !isTablet,
  isPC = !isPhone && !isAndroid && !isSymbian;
/*   isMobile = isPhone || isAndroid || isSymbian, */
/*   isMicroMessenger = /(?:MicroMessenger)/.test(ua); */

// 链接标准化函数：根据当前页面URL修改链接的协议和域名
export const normalizeLink = (link) => {
  if (!link) return link;
  try {
    const currentProtocol = window.location.protocol; // 'https:' 或 'http:'
    // 解析原始链接
    const url = new URL(link);
    // 替换为当前页面的协议和域名，保持路径不变
    url.protocol = currentProtocol;
    return url.href;
  } catch (e) {
    // 如果解析失败，返回原始链接
    console.error("链接解析失败:", link, e);
    return link;
  }
};

export default {
  isPC() {
    return isPC;
  },
  normalizeLink,
};
